@if (loading$ | async) {
  <div class="m-4 w-full flex justify-center">
    <mat-spinner class="loading-spinner"></mat-spinner>
  </div>
}
@if (!(loading$ | async)) {
  <div>
    @if (hasQuotingMessages$ | async) {
      <div class="messages">
        @for (message of quotingMessages$ | async; track message) {
          <app-server-message [message]="message"></app-server-message>
        }
      </div>
    }
    @if (shipment$ | async; as shipment) {
      <div class="summary flex flex-col md:flex-row p-1">
        @if (submitted$ | async) {
          <dl>
            <dd>
              <app-courier-logo [serviceLogo]="shipment.quote.serviceLogo"></app-courier-logo>
              <div>{{ shipment.quote.serviceName }}</div>
            </dd>
            <dt i18n>Master Tracking Number</dt>
            <dd>{{ shipment.trackingNumber }}</dd>
          </dl>
        }
        <dl>
          <dt i18n>Created At</dt>
          <dd>{{ shipment.createdAt | date }}</dd>
          <dt i18n>Created By</dt>
          <dd>{{ shipment.username }}</dd>
          <dt i18n>References</dt>
          <dd>
            @for (ref of shipment.references | keyvalue; track ref) {
              <div>{{ ref.value }}</div>
            }
          </dd>
        </dl>
        <dl>
          <dt i18n>Shipper</dt>
          <dd><app-shipment-card [card]="shipment.shipper"></app-shipment-card></dd>
        </dl>
        <dl>
          <dt i18n>Consignee</dt>
          <dd><app-shipment-card [card]="shipment.destination"></app-shipment-card></dd>
        </dl>
        @if (shipment.quote) {
          <dl>
            <dt i18n>Price</dt>
            <dd>@if (shipment.quote) {
              <app-price-breakdown [price]="shipment.quote.customer"></app-price-breakdown>
            }</dd>
          </dl>
        }
        @if (!shipment.quote && shipment.quotes.length > 0) {
          <dl>
            <dt i18n>Selected Quote</dt>
            <dd>
              <mat-select [formControl]="preSelectedQuoteControl" (selectionChange)="preSelectedQuoteChange($event.value)">
                @for (quote of shipment.quotes; track quote) {
                  <mat-option [value]="quote.id">
                    {{ quote.courierName }} {{ quote.serviceName }} {{ quote.customer?.gross | currency:quote.customer?.currency }}
                  </mat-option>
                }
              </mat-select>
              @if (busy$ | async) {
                <mat-spinner diameter="24"></mat-spinner>
              }
            </dd>
            @if (preSelectedQuote$ | async; as quote) {
              @if (!!quote.estimatedDeliveryDate) {
                <dt i18n>Estimated Delivery</dt>
                <dd>
                  {{ quote.estimatedDeliveryDate }}
                  @if (quote.estimatedDeliveryTime) {
                    <span>
                      {{ quote.estimatedDeliveryTime }}
                    </span>
                  }
                </dd>
              }
            }
          </dl>
        }
        @if (preSelectedQuote$ | async; as quote) {
          @if (quote && quote.customer && quote.customer.gross) {
            <dl>
              <dt i18n>Price</dt>
              <dd>
                <app-price-breakdown [price]="quote.customer"></app-price-breakdown>
              </dd>
            </dl>
          }
        }
        <dl>
          <dt i18n>Packages</dt>
          <dd>
            {{ packageQuantity$ | async }} &times; {{ shipment.packagingType | packagingType | async }}
          </dd>
          <dt i18n>Weight</dt>
          <dd>
            {{ packageWeight$ | async | weight:shipment.weightUnit }}
          </dd>
        </dl>
        @if (submitted$ | async) {
          <dl>
            <dt i18n>Documents</dt>
            <dd>
              @for (document of shipment.documents; track document) {
                <div>
                  <app-document-link [document]="document"></app-document-link>
                </div>
              }
            </dd>
          </dl>
        }
      </div>
    }
  </div>
}
